import { render, staticRenderFns } from "./deleted_trees.vue?vue&type=template&id=2e389cb2&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./deleted_trees.vue?vue&type=script&lang=js&"
export * from "./deleted_trees.vue?vue&type=script&lang=js&"
import style0 from "./deleted_trees.vue?vue&type=style&index=0&id=2e389cb2&prod&lang=css&"
import style1 from "./deleted_trees.vue?vue&type=style&index=1&id=2e389cb2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e389cb2",
  null
  
)

export default component.exports